import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { CONTACT_US_PAGE_META } from 'lib/enums/contactUs';
import Header from './Header';
//import MessageBanner from './MessageBanner';
import RecommendedLinks from './RecommendedLinks';
import Covid19Faqs from './Covid19Faqs';
import FAQsLinks from './FAQsLinks';

const ContactUsLayout = ({ pageTitle }) => (
  <Fragment>
    <Helmet meta={CONTACT_US_PAGE_META} title={pageTitle} />
    <Header title="Contact us" description="Here's how to get in contact with us, online or via our contact centre." py={14} />
    {/*<MessageBanner />*/}
    <Covid19Faqs />
    <RecommendedLinks />
    <FAQsLinks />
  </Fragment>
);

ContactUsLayout.propTypes = {
  pageTitle: PropTypes.string,
};

ContactUsLayout.defaultProps = {
  pageTitle: 'Contact us | Qantas Hotels Australia',
};

ContactUsLayout.displayName = 'ContactUsLayout';

export default ContactUsLayout;
